'use client';
import Spinner from '@/components/atoms/Spinner';
import { useTranslations } from 'next-intl';
import { useState } from 'react';

interface Errors {
    message?: string;
    email?: string;
}

interface NewsLetterForm {
    description: string | null;
}

export default function NewsletterForm({ description = null }: NewsLetterForm) {
    const t = useTranslations('NewsletterForm');

    const [errors, setErrors] = useState({} as Errors);
    const [success, setSuccess] = useState(false);
    const [loading, setLoading] = useState(false);

    const signUp = async (event: React.FormEvent<HTMLFormElement>) => {
        event.preventDefault();

        setErrors({});
        setLoading(true);

        try {
            const res = await fetch('/api/signup', {
                body: JSON.stringify({
                    email: (event.target as HTMLFormElement).email.value,
                }),
                headers: {
                    'Content-Type': 'application/json',
                    Accept: 'application/json',
                },
                method: 'POST',
            });

            const result = await res.json();

            if (res.status === 200) {
                setSuccess(true);
            } else {
                setErrors(result);
            }

            return;
        } catch (error) {
            setErrors({
                message: (error as Error).message,
            });
        } finally {
            setLoading(false);
        }
    };

    return success === false ? (
        <div className={'relative'}>
            {description && (
                <div
                    className={'rich-text pb-4'}
                    dangerouslySetInnerHTML={{ __html: description }}
                />
            )}

            <form onSubmit={signUp} className={'relative w-full'}>
                {loading && (
                    <div
                        className={
                            'absolute inset-0 flex items-center justify-center bg-haug-choco-70 opacity-90'
                        }
                    >
                        <Spinner variant="white" size="sm" />
                    </div>
                )}

                <label htmlFor="email" className="mb-1 block">
                    {t('email.label')}:
                </label>
                <input
                    id="email"
                    name="email"
                    type="email"
                    required
                    className="w-full px-2 py-1 text-base text-haug-choco-100"
                    placeholder={t('email.placeholder')}
                    autoComplete="email"
                />

                {errors?.email && (
                    <div className="border border-haug-coral-100 bg-haug-coral-30 p-2 text-haug-coral-100">
                        {errors.email}
                    </div>
                )}

                <button
                    className="mt-4 bg-haug-blue-200 px-4 py-1 font-bold text-base text-haug-ivory-30 uppercase"
                    type="submit"
                >
                    {t('submit')}
                </button>
            </form>
        </div>
    ) : (
        <div className="border-success-100 bg-success-30 p-2 text-base text-success-100">
            {t('success-message')}
        </div>
    );
}
